import { render, staticRenderFns } from "./stepper.vue?vue&type=template&id=12c4d88e&scoped=true&"
import script from "./stepper.vue?vue&type=script&lang=js&"
export * from "./stepper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c4d88e",
  null
  
)

export default component.exports